import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const getTicketById = async (eventId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_EVENT_TICKET_BY_ID}?EventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getTicketByEventId = async (eventId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.get(
      `${apiendpoints.GET_TICKET_BY_EVENT_ID}?EventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const checkTicketEligibility = async (ticketId, quantity) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TICKET_ELIGIBILITY}?ticketId=${ticketId}&quantity=${quantity}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getTicketInsights = async (eventId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_TICKET_INSIGHTS_BY_EVENT_ID}?EventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const createTicket = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true, true));
    const response = await axioClient.post(
      apiendpoints.CREATE_EVENT_TICKET,
      data
    );
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Tickets  Transtions Reports
export const getAllTicketsTranctionsReports = async (
  organizerId,
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_TICKET_TRANSTION_REPORT}?organizerId=${organizerId}&eventId=${eventId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getAllTicketsTranctionsAdminReports = async (
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_TICKET_TRANSTION_REPORT_ADMIN}?pageNumber=${pageNumber}&pageSize=${pageSize}&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const refundTicket = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(false, true));
    const response = await axioClient.post(apiendpoints.TICKET_REFUND, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const redeemTicket = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(false, true));
    const response = await axioClient.post(apiendpoints.REDEEM_EVENT_TCIKET, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


